<template>
    <c-dialog ref="dialog" title="选择配送方式" width="900" @resolve="resolve">
        <m-search ref="search" @search="searchHandle">
            <m-search-item label="配送方式代码">
                <c-input name="code"></c-input>
            </m-search-item>
            <m-search-item label="配送方式名称">
                <c-input name="name"></c-input>
            </m-search-item>
        </m-search>
        <c-table ref="table" height="400" :paging="true">
            <c-table-column
                    label="选择"
                    type="selector"
                    width="25"
            ></c-table-column>

            <c-table-column
                    label="配送方式代码"
                    name="company_code"
                    width="110"
            >
            </c-table-column>

            <c-table-column
                    label="配送方式名称"
                    name="name"
                    width="140"
            >
            </c-table-column>

            <c-table-column
                    label="创建日期"
                    name="create_date"
                    width="140"
            >
            </c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>
export default {
    props: {
        multiple: Boolean
    },

    methods: {

        searchHandle(data) {
            if (!data)
                data = {};
            data.main_stationed_id = 0;
            this.$refs.table.load({
                url: '/logistics_company/list',
                data
            });
        },
        open() {
            this.$refs.dialog.open();
            this.searchHandle({});
        },

        resolve(stop) {
            var data = this.$refs.table.getRow('selected');
            if (!data.length) {
                stop();
                this.$message({
                    message: '请选择需要添加的配送方式'
                });
                return;
            }
            this.$emit('resolve', Array.from(data, item => item.data));
        }
    }
}
</script>